export default __webpack_public_path__ + "static/media/Assets.52766bba.svg";